import { useQuery } from '@tanstack/react-query';

import { useCustomAppClient } from 'api/custom-client';

import type { CopilotModelResponse } from 'app/modules/wallforming/components/copilot/types/copilotTypes';

export const useCopilotModel = () => {
    const getCopilotModel = useCustomAppClient<CopilotModelResponse>();

    return useQuery({
        queryKey: ['copilot-models'],
        queryFn: ({ signal }) => getCopilotModel({ url: '/copilot/model', method: 'GET', signal })
    });
};
